/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IPortalBranding {
     getBrandingByInvoice(encryptedId: string, cancelToken?: CancelToken): AxiosPromise<BrandData>;
 getBrandingByProposal(encryptedId: string, cancelToken?: CancelToken): AxiosPromise<BrandData>;
 getBrandingByServiceAgreement(serviceAgreementId: number, cancelToken?: CancelToken): AxiosPromise<BrandData>;
}

export const BASE_URL_TOKEN_PortalBranding = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class PortalBranding implements IPortalBranding {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private readonly axios: AxiosInstance, @inject(BASE_URL_TOKEN_PortalBranding) @optional() private readonly baseUrl = "") {
    }

    getBrandingByInvoice(encryptedId: string, cancelToken?: CancelToken): AxiosPromise<BrandData> {
        let url_ = "/v1/customerportal2/branding/invoices/{encryptedId}";
        if (encryptedId === undefined || encryptedId === null)
            throw new Error("The parameter 'encryptedId' must be defined.");
        url_ = url_.replace("{encryptedId}", encodeURIComponent("" + encryptedId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<BrandData>(options_));
    }

    getBrandingByProposal(encryptedId: string, cancelToken?: CancelToken): AxiosPromise<BrandData> {
        let url_ = "/v1/customerportal2/branding/proposals/{encryptedId}";
        if (encryptedId === undefined || encryptedId === null)
            throw new Error("The parameter 'encryptedId' must be defined.");
        url_ = url_.replace("{encryptedId}", encodeURIComponent("" + encryptedId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<BrandData>(options_));
    }

    getBrandingByServiceAgreement(serviceAgreementId: number, cancelToken?: CancelToken): AxiosPromise<BrandData> {
        let url_ = "/v1/customerportal2/branding/service-agreements/{serviceAgreementId}";
        if (serviceAgreementId === undefined || serviceAgreementId === null)
            throw new Error("The parameter 'serviceAgreementId' must be defined.");
        url_ = url_.replace("{serviceAgreementId}", encodeURIComponent("" + serviceAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<BrandData>(options_));
    }
}

export interface BrandData {
    officialName: string;
    phone?: string | undefined;
    email?: string | undefined;
    logoUrl?: string | undefined;
}